import dynamic from 'next/dynamic';
const BookCopiesMap = dynamic(() => import('@/components/Pages/Bookle/BookCopiesMap'), {
  ssr: false,
});

export default function BookLocationMap({ marker }) {
  return (
    <BookCopiesMap
      marker={marker}
      width={300}
      height={450}
    ></BookCopiesMap>
  );
}
